import { useEffect } from 'react';
import Router from 'next/router';
import { proxy, useSnapshot } from 'valtio';

export const PopState = proxy({
  isPopStateEvent: false,
});

/**
 * Detects if the current route change was triggered by a browser back or forward button click
 */
export const usePopState = () => {
  return useSnapshot(PopState);
};

/**
 * Tracks if the current route change was triggered by a browser back or forward button click
 * This is useful for knowing if we should scroll to the top of the page or not
 * Use this hook in _app.tsx or anywhere else that doesn't re-render on route change
 */
export const useTrackPopState = () => {
  useEffect(() => {
    Router.beforePopState(() => (PopState.isPopStateEvent = true));
  }, []);
};
